import {SearchValue} from "../catalog/catalog.functions";

export enum SearchType {
    PART = "part",
    CAR  = "car",
    VIN  = "vin",
    OEM_LIST = "oem_list"
}

export interface SearchParams {
    type?: SearchType,
    searchString?: SearchValue;
    manufacturer?: string;
    model?: string;
    engine?: string;
    group?: string;
    subgroup?: string;
    vehicleId?: string;
}